import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import IC1 from "../../assets/social/fb.png";
import IC2 from "../../assets/social/in.png";
import IC3 from "../../assets/social/lk.png";
import IC4 from "../../assets/social/yt.png";
import { HashLink } from "react-router-hash-link";
import GoogleRating from "../googleReviews/GoogleRating";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="footerBase">
      <div className="footerContent">
        <p className="contactHomeSubTxtFoot">
          Top Roofing Company in Texas.We are your trusted partner in elevating
          the beauty and functionality of your home
        </p>
        <div className="footerTop">
          <div className="footerGrid">
            <p className="footerHeadTxt">Quick Links</p>
            <div className="footerGridFlexContent">
              <div className="footerGridFlex">
                <Link
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  to="/home"
                  style={{ textDecoration: "none" }}
                >
                  <p className="footerLinkTxt">Home</p>
                </Link>
                <Link
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  to="/roofing"
                  style={{ textDecoration: "none" }}
                >
                  <p className="footerLinkTxt">Roofing</p>
                </Link>
                <Link
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  to="/storm-service"
                  style={{ textDecoration: "none" }}
                >
                  <p className="footerLinkTxt">Storm Services</p>
                </Link>
                <Link
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  to="/financing"
                  style={{ textDecoration: "none" }}
                >
                  <p className="footerLinkTxt">Financing</p>
                </Link>
                <a
  href="https://restorationroofingremodeling.com/blog/"
  target="_self"
  rel="noopener noreferrer"
  style={{ textDecoration: "none" }}
>
  <p className="footerLinkTxt">Blog</p>
</a>
              </div>
              <div className="footerGridFlex">
                <Link
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  to="/videos"
                  style={{ textDecoration: "none" }}
                >
                  <p className="footerLinkTxt">Videos</p>
                </Link>

                <HashLink
                  smooth
                  to="/about-us#reviews"
                  style={{ textDecoration: "none" }}
                >
                  <p className="footerLinkTxt">Reviews</p>
                </HashLink>
                <Link
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  to="/about-us"
                  style={{ textDecoration: "none" }}
                >
                  <p className="footerLinkTxt">About</p>
                </Link>
                <Link
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  to="/contact-us"
                  style={{ textDecoration: "none" }}
                >
                  <p className="footerLinkTxt">Contact</p>
                </Link>
                <a
  href="https://restorationroofingremodeling.com/sitemap.html"
  target="_blank"
  rel="noopener noreferrer"
  style={{ textDecoration: "none" }}
>
  <p className="footerLinkTxt">Sitemap</p>
</a>
              </div>
            </div>
          </div>

          <div className="footerGridFollow">
            <p className="footerHeadTxt">Follow us</p>

            <div className="footerIcons">
              <a
                href="https://www.facebook.com/RestorationRoofingRemodeling"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={IC1} alt="logo" className="socialIcon" />
              </a>
              <a
                href="https://www.instagram.com/restorationroofingremodeling/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={IC2} alt="logo" className="socialIcon" />
              </a>
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={IC3} alt="logo" className="socialIcon" />
              </a>
              <a
                href="https://www.youtube.com/@RRRHoustonTX/videos"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={IC4} alt="logo" className="socialIcon" />
              </a>
            </div>
            <GoogleRating variant="footer" />
          </div>
          <div className="footerGrid">
            <p
              className="footerHeadTxt"
              style={{
                textDecoration: "underline",
                textUnderlineOffset: "10px",
              }}
            >
              Contact Us
            </p>
            <p className="footerLinkTxt">Restoration Roofing & Remodeling</p>
            <p className="footerLinkTxt">6902 fm 2920</p>
            <p className="footerLinkTxt">Suite 2</p>
            <p className="footerLinkTxt">Spring, TX 77379</p>
            <p className="footerLinkTxt">
              <a href="tel:8323885393">
                Phone: (832) 388-5393
              </a>
            </p>
          </div>
        </div>
        <div className="footerBottomDivFollow">
          <div className="folloWRespDiv">
            <p className="footerHeadTxt">Follow us</p>

            <div className="footerIcons">
              <a href="https://www.facebook.com/">
                <img
                  src="https://s3.ap-south-1.amazonaws.com/aimaradoors.pennonn.com/icons/fb.png"
                  alt="logo"
                  className="socialIcon"
                />
              </a>
              <a href="https://www.linkedin.com/">
                <img
                  src="https://s3.ap-south-1.amazonaws.com/aimaradoors.pennonn.com/icons/insta.png"
                  alt="logo"
                  className="socialIcon"
                />
              </a>
              <a href="https://twitter.com/">
                <img
                  src="https://s3.ap-south-1.amazonaws.com/aimaradoors.pennonn.com/icons/twitter.png"
                  alt="logo"
                  className="socialIcon"
                />
              </a>
              <a href="https://www.instagram.com/">
                <img
                  src="https://s3.ap-south-1.amazonaws.com/aimaradoors.pennonn.com/icons/in.png"
                  alt="logo"
                  className="socialIcon"
                />
              </a>
            </div>
            <GoogleRating variant="footer" />
          </div>
        </div>
        <div className="footerBottomDiv">
          <p className="copyTxt">
            &copy; {currentYear} RRR. All Rights Reserved
          </p>
          <a
            href="https://pennonn.com/"
            rel="noopener noreferrer"
            target="_blank"
            style={{ textDecoration: "none", cursor: "pointer" }}
          >
            <p className="copyTxt">Powered By: Pennonn Inc</p>
          </a>
        </div>
      </div>
    </div>
  );
}
